<script>
	import { metaStore } from '#lib/store/metaStore.js';
	import { Pencil } from '@lucide/svelte';

	const contactButtonClick = () => {
		metaStore.set({ showContactForm: !$metaStore.showContactForm });
		if ($metaStore.screen !== 'desktop') metaStore.set({ showSidebar: false });
	};
</script>

<button
	onclick={contactButtonClick}
	class="flex items-center rounded-xl border bg-cyan-100 py-4 pl-4 pr-6 font-medium text-blue-900 hover:bg-cyan-200 hover:shadow-md dark:border-cyan-900 dark:bg-cyan-950 dark:text-cyan-200 dark:hover:bg-cyan-900"
>
	<Pencil class="mr-4 h-6 w-6 font-bold" />
	Contact Me
</button>
